import { H2} from '../Components/Reusable'
import { Container, Row ,Col} from "react-bootstrap";
import me from '../assets/me.jpg'
import '../styles/intro.css'
const currentYear = new Date().getFullYear();
const yearsOfExperience = currentYear - 2021;
const About = () => {
  return (
    <section data-aos="fade-up" data-aos-duration="1000" id='about' className='intro-container'>
      <div className='intro-wrapper'>
        <Container>
          <Row>
            <Col md={6} sm={12}>
              <div className='intro-text'>
                <H2  data-aos="fade-in" data-aos-delay="100">About Me</H2>
                <h4  data-aos="fade-in" data-aos-delay="200">
                 Frontend Web Developer, Based in Nigeria
                  <span className='dot'>.</span>
                </h4>
                <div className='intro-info'>
                  <p  data-aos="fade-in" data-aos-delay="300">                  
                   A proficient JavaScript frontend engineer with {yearsOfExperience} years of experience building enterprise-grade solutions that solve real-world problems. Skilled in React/NextJS, Redux, TypeScript, JavaScript, HTML, SASS, Firebase, and Git, with a strong eye for design, smooth animations, and responsive UI. Actively exploring mobile development with Android Studio and expanding into Web3 technologies to stay ahead of the curve.
                    <span className='dot'>.</span>
                  </p>
                
                </div>
              </div>
            </Col>
            <Col md={6} sm={12}>
              <div className='intro-img'>
                <img src={me} alt='me'  data-aos="fade-left" data-aos-delay="100" data-aos-easing="spring"/>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
}

export default About
